import { render, staticRenderFns } from "./HeaderTitles.vue?vue&type=template&id=2ff26f34&scoped=true&"
import script from "./HeaderTitles.vue?vue&type=script&lang=ts&"
export * from "./HeaderTitles.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderTitles.vue?vue&type=style&index=0&id=2ff26f34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff26f34",
  null
  
)

export default component.exports